/*
 * Copyright (c) 2020 WildFireChat. All rights reserved.
 */

import NotificationMessageContent from "./notificationMessageContent";

export default class GroupNotificationContent extends NotificationMessageContent {
    groupId = '';
    constructor(type) {
        super(type);
    }
}
